import CassieContainer from './CassieContainer';
import { CloseContext } from './websocket/types';

interface CassieInjectorProps {
  contactId: string | undefined;
  closeContext?: CloseContext;
}

const CassieInjector: React.FC<CassieInjectorProps> = ({ contactId, closeContext }) => {
  return <CassieContainer contactId={contactId} closeContext={closeContext} />;
};

export default CassieInjector;
